import firebase from "firebase/app";
import uniqid from "uniqid";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { DistributionChannel } from "astrid-firestore/src/api/distribution/types/DistributionChannel";
import createExportPreset from "astrid-firestore/src/api/exports/createExportPreset";

import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

export default function CreateExportPresetForm({ onClose }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const { form, onSubmit, error } = useSimpleForm({
		schema: DistributionChannel,
		defaultValues: {
			name: "",
		},
		onSubmit: ({ name }) => {
			return createExportPreset(firebase, { id: uniqid(), name });
		},
		onSuccess: ({ id }) => navigate(id),
	});

	return (
		<Form.Modal
			header={t("createExportPreset", "Create export preset")}
			size="tiny"
			form={form}
			error={error}
			onSubmit={onSubmit}
			onClose={onClose}
		>
			<Form.Input name="name" label={t("name", "Name")} />
		</Form.Modal>
	);
}
